import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Row, Col, BreadcrumbItem } from "reactstrap";
import ThemePlaceholder from "components/Common/ThemePlaceholder";

const Breadcrumb = ({ breadcrumbItem, title, loading = false }) => {
  return (
    <Row>
      <Col xs={12}>
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 className="mb-sm-0 font-size-18">
            {loading ? (
              <ThemePlaceholder style={{ width: 200, height: 24 }} />
            ) : (
              breadcrumbItem
            )}
          </h4>
          <div className="page-title-right">
            <ol className="breadcrumb m-0">
              <BreadcrumbItem>
                {loading ? (
                  <ThemePlaceholder style={{ width: 100, height: 16 }} />
                ) : (
                  <Link to="#">{title}</Link>
                )}
              </BreadcrumbItem>
              <BreadcrumbItem active>
                {loading ? (
                  <ThemePlaceholder style={{ width: 120, height: 16 }} />
                ) : (
                  breadcrumbItem
                )}
              </BreadcrumbItem>
            </ol>
          </div>
        </div>
      </Col>
    </Row>
  );
};

Breadcrumb.propTypes = {
  breadcrumbItem: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node, // ✅ allows JSX elements like <CopyButton />
  ]),
  title: PropTypes.string,
  loading: PropTypes.bool,
};

export default Breadcrumb;
